import { defineComponent as H, openBlock as t, createElementBlock as r, Fragment as C, renderList as I, createBlock as f, resolveDynamicComponent as V, normalizeProps as N, guardReactiveProps as z, withCtx as x, createElementVNode as o, toDisplayString as m, createCommentVNode as i, ref as D, computed as v, unref as M, normalizeClass as S, inject as P, useSlots as W, onMounted as F, mergeProps as G, renderSlot as R } from "vue";
import { _ as U } from "./chunks/FrontiersImage.vue_vue_type_script_setup_true_lang.2836b6c7.js";
import "./frontiersImage.es.js";
import { g as q } from "./chunks/getDataEventValue.a20ca383.js";
import { OnClickOutside as K } from "@vueuse/components";
import { _ as Q } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import { Breadcrumbs as X } from "./breadcrumbs.es.js";
import './assets/index19.css';const Y = { class: "Metrics" }, Z = { class: "Metrics__numbers__main" }, ee = {
  key: 0,
  class: "Metrics__numbers__prefix"
}, se = { class: "Metrics__numbers__number" }, te = {
  key: 1,
  class: "Metrics__numbers__suffix"
}, ne = { class: "Metrics__numbers__text" }, oe = /* @__PURE__ */ H({
  __name: "Metrics",
  props: {
    items: {}
  },
  setup(c) {
    const s = (n) => n.link ? "a" : "div", p = (n) => {
      let d = {};
      return n.link && (d = Object.assign(d, {
        href: n.link.url,
        target: n.link.target,
        "aria-label": n.link.ariaLabel,
        "data-event": q("metrics", "a", n.text)
      })), d;
    }, h = (n) => n.toLocaleString("en-US");
    return (n, d) => (t(), r("ul", Y, [
      (t(!0), r(C, null, I(n.items, (a, l) => (t(), r("li", {
        class: "Metrics__numbers__item",
        key: l
      }, [
        (t(), f(V(s(a)), N(z(p(a))), {
          default: x(() => [
            o("div", {
              ref_for: !0,
              ref: "lines",
              class: "Metrics__numbers__line"
            }, null, 512),
            o("div", {
              ref_for: !0,
              ref: "numbers",
              class: "Metrics__numbers__mask"
            }, [
              o("p", Z, [
                a.prefix ? (t(), r("span", ee, m(a.prefix), 1)) : i("", !0),
                o("span", se, m(h(a.number)), 1),
                a.suffix ? (t(), r("span", te, m(a.suffix), 1)) : i("", !0)
              ]),
              o("p", ne, m(a.text), 1)
            ], 512)
          ]),
          _: 2
        }, 1040))
      ]))), 128))
    ]));
  }
});
const re = ["data-event"], ae = { class: "CrossListedSectionsDropDown__menuWrapper" }, ie = { class: "CrossListedSectionsDropDown__menu" }, le = ["href", "data-event"], ue = ["data-event"], ce = /* @__PURE__ */ H({
  __name: "CrossListedSectionsDropDown",
  props: {
    crossListedSections: {},
    currentJournalId: {}
  },
  setup(c) {
    const s = c, p = D(!1), h = v(() => `This section appears in ${s.crossListedSections.length} journals`), n = (l) => l === s.currentJournalId, d = () => {
      p.value = !p.value;
    }, a = () => {
      p.value = !1;
    };
    return (l, k) => (t(), f(M(K), { onTrigger: a }, {
      default: x(() => [
        o("div", {
          class: S(["CrossListedSectionsDropDown", { "CrossListedSectionsDropDown--open": p.value }])
        }, [
          o("button", {
            class: "CrossListedSectionsDropDown__button",
            onClick: d,
            "data-event": l.$ga.getDataEventValue(
              "crossListedSectionsDropDown",
              "button",
              "toggle"
            )
          }, m(h.value), 9, re),
          o("div", ae, [
            o("ul", ie, [
              (t(!0), r(C, null, I(l.crossListedSections, (_) => (t(), r("li", {
                key: _.journalId
              }, [
                o("a", {
                  href: _.slug,
                  class: S(["CrossListedSectionsDropDown__option", {
                    "CrossListedSectionsDropDown__option--active": n(
                      _.journalId
                    )
                  }]),
                  "data-event": l.$ga.getDataEventValue(
                    "crossListedSectionsDropDown",
                    "a",
                    _.journalId.toString()
                  )
                }, m(_.journalName), 11, le)
              ]))), 128))
            ]),
            o("button", {
              class: "CrossListedSectionsDropDown__mobileClose",
              "aria-label": "Close",
              onClick: a,
              "data-event": l.$ga.getDataEventValue(
                "crossListedSectionsDropDown",
                "button",
                "close"
              )
            }, null, 8, ue)
          ])
        ], 2)
      ]),
      _: 1
    }));
  }
});
const de = /* @__PURE__ */ Q(ce, [["__scopeId", "data-v-fa71c3c5"]]), _e = {
  key: 1,
  class: "MainHeader__mask MainHeader__mask--gradient"
}, pe = {
  class: "is-inside-mask",
  autoplay: !0,
  loop: !0,
  playsinline: "",
  controls: !1,
  muted: !0,
  tabindex: "-1",
  preload: "auto"
}, ve = ["src", "type"], me = /* @__PURE__ */ o("div", { class: "MainHeader__ibar" }, null, -1), fe = {
  key: 1,
  class: "MainHeader__subtitle"
}, ge = {
  key: 2,
  class: "MainHeader__actions"
}, he = { class: "MainHeader__actionsWrapper" }, Le = {
  key: 1,
  class: "MainHeader__links"
}, be = ["href", "target", "data-event"], De = {
  key: 2,
  class: "MainHeader__buttons"
}, $e = /* @__PURE__ */ H({
  __name: "MainHeader",
  props: {
    title: {},
    titleAllowedTags: { default: () => [] },
    subtitle: {},
    frontiersImage: {},
    impactNumbers: {},
    links: {},
    breadcrumbs: {},
    crossListedSections: { default: () => [] },
    currentJournalId: {},
    videos: {},
    aboutUs: {},
    aboutJournal: {},
    journal: {},
    increasedHeight: { type: Boolean, default: !1 },
    heading: { default: "h3" }
  },
  setup(c) {
    const s = c, p = P("sanitize"), h = s.currentJournalId, n = D(s.frontiersImage !== void 0);
    D(!1);
    const d = D(!0), a = D(
      n.value || s.videos && s.videos.length > 0
    ), l = v(() => {
      var u;
      const e = ["MainHeader"];
      return E.value && e.push("MainHeader--bgImage"), (u = s.crossListedSections) != null && u.length && e.push("MainHeader--crossListedSections"), s.increasedHeight && e.push("MainHeader--increasedHeight"), e;
    }), k = v(() => s.impactNumbers ? s.impactNumbers.length > 0 : !1), _ = v(() => s.links ? s.links.length > 0 : !1), E = v(() => n.value || L.value !== void 0 && L.value.url.length > 0), y = v(() => !!W().buttons), O = v(() => k.value || _.value || y.value), L = v(() => A(d.value) || B()), j = () => {
      n.value = !1;
    }, A = (e) => {
      if (s.videos && s.videos.length > 0) {
        let u;
        if (e ? u = s.videos.find((g) => g.resolution === "Desktop") : u = s.videos.find(
          (g) => g.resolution === "TabletPortrait"
        ), u)
          return {
            url: u.url,
            extension: w(u),
            resolution: u.resolution
          };
      }
    }, B = () => {
      if (s.videos && s.videos.length > 0)
        return {
          url: s.videos[0].url,
          extension: w(s.videos[0]),
          resolution: s.videos[0].resolution
        };
    }, w = (e) => e.extension ? e.extension : e.url.substring(e.url.lastIndexOf(".") + 1).toLocaleLowerCase();
    return F(() => {
      d.value = window.innerWidth > 1024;
    }), (e, u) => {
      var g, $, T;
      return t(), r("header", {
        class: S(l.value)
      }, [
        n.value ? (t(), f(M(U), G({
          key: 0,
          class: ["MainHeader__mask", { "MainHeader__mask--gradient": a.value }]
        }, e.frontiersImage, { onError: j }), null, 16, ["class"])) : i("", !0),
        (g = L.value) != null && g.url ? (t(), r("div", _e, [
          o("video", pe, [
            o("source", {
              src: ($ = L.value) == null ? void 0 : $.url,
              type: "video/" + ((T = L.value) == null ? void 0 : T.extension)
            }, null, 8, ve)
          ])
        ])) : i("", !0),
        me,
        o("div", {
          class: S(["MainHeader__body", { "MainHeader__body--noActions": !O.value }])
        }, [
          e.breadcrumbs ? (t(), f(M(X), {
            key: 0,
            items: e.breadcrumbs
          }, null, 8, ["items"])) : i("", !0),
          (t(), f(V(e.heading), {
            class: "MainHeader__title",
            innerHTML: M(p)(e.title, { ALLOWED_TAGS: e.titleAllowedTags })
          }, null, 8, ["innerHTML"])),
          e.subtitle ? (t(), r("p", fe, m(e.subtitle), 1)) : i("", !0),
          e.crossListedSections && e.crossListedSections.length > 0 ? (t(), f(de, {
            key: 2,
            crossListedSections: e.crossListedSections,
            currentJournalId: M(h)
          }, null, 8, ["crossListedSections", "currentJournalId"])) : i("", !0)
        ], 2),
        k.value || _.value || y.value ? (t(), r("div", ge, [
          o("div", he, [
            k.value ? (t(), f(oe, {
              key: 0,
              ref: "numberList",
              items: e.impactNumbers
            }, null, 8, ["items"])) : i("", !0),
            _.value ? (t(), r("div", Le, [
              (t(!0), r(C, null, I(e.links, (b, J) => (t(), r("a", {
                class: "MainHeader__link",
                key: J,
                href: b.url,
                target: b.target,
                "data-event": e.$ga.getDataEventValue(
                  "mainHeader",
                  "links",
                  b.dataEvent || b.text
                )
              }, m(b.text), 9, be))), 128))
            ])) : i("", !0),
            y.value ? (t(), r("div", De, [
              R(e.$slots, "buttons")
            ])) : i("", !0)
          ])
        ])) : i("", !0)
      ], 2);
    };
  }
});
var Me = /* @__PURE__ */ ((c) => (c.Level1FullHeight = "levelOne--FullHeight", c.Level1HalfHeight = "levelOne--HalfHeight", c.Level2 = "levelTwo", c))(Me || {});
export {
  $e as MainHeader,
  Me as MainHeaderEnum
};
